define('webshopQuotationsListView',[
  'module',
  'marionette',
  'underscore',
  'entities/webshop/quotations',
  'template!webshopQuotationsListView'
], function (
  Module,
  Marionette,
  _,
  QuotationsApi,
  Tpl
) {
  'use strict';

  // Left pane: the quotations found, one page at a time ("Show more").
  Module.exports = Marionette.ItemView.extend({
    template: Tpl,
    className: 'webshop-quotations-list-view',

    events: {
      'click .quotation': 'onSelect',
      'click .more': 'onMore'
    },

    initialize: function () {
      this.items = [];
      this.total = 0;
      this.selectedId = null;
      this.loading = true;
    },

    setItems: function (items, total, selectedId) {
      this.items = items || [];
      this.total = total;
      this.selectedId = selectedId;
      this.loading = false;
      this.render();
    },

    setLoading: function (loading) {
      this.loading = loading;
      this.render();
    },

    setSelected: function (id) {
      this.selectedId = id;
      this.$('.quotation').removeClass('selected');
      this.$('.quotation[data-id="' + id + '"]').addClass('selected');
    },

    serializeData: function () {
      return {
        items: _.map(this.items, function (q) {
          return {
            id: q.id,
            reference: q.reference,
            productName: q.productName,
            productCode: q.productCode,
            quantity: q.quantity,
            total: QuotationsApi.formatPrice(q.totalPrice, q.currency),
            customer: QuotationsApi.customerLabel(q.customer),
            date: QuotationsApi.formatDate(q.createdAt),
            site: _.compact([q.domain ? '.' + q.domain : '', q.locale]).join(' / ')
          };
        }),
        total: this.total,
        loading: this.loading,
        selectedId: this.selectedId
      };
    },

    onSelect: function (e) {
      this.trigger('select', parseInt($(e.currentTarget).data('id'), 10));
    },

    onMore: function () {
      this.trigger('more');
    }
  });
});

